import { IconCloseMediumOutline } from '@teamleader/ahoy';
import { translate } from '@teamleader/i18n';
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';

import Footer from './Footer';
import * as styles from './styles.css';
import Box, { BoxProps } from '../Box';
import IconButton from '../IconButton';

interface SubComponents {
  Footer: typeof Footer;
}

interface MobilePopupProps extends BoxProps {
  onClose?: () => void;
  inverse?: boolean;
}

const MobilePopup: React.FC<MobilePopupProps> & SubComponents = ({
  onClose,
  inverse,
  className,
  children,
  ...rest
}) => {
  return ReactDOM.createPortal(
    <>
      <Box
        className={cx(styles['mobile-popup-background'], { [styles['mobile-popup-background--inverse']]: inverse })}
      />
      <Box className={cx(styles['mobile-popup'], { [styles['mobile-popup--inverse']]: inverse }, className)} {...rest}>
        {onClose && (
          <IconButton
            marginTop={3}
            paddingHorizontal={4}
            paddingVertical={3}
            className={styles['close-button']}
            icon={<IconCloseMediumOutline className={styles['close-icon']} />}
            onClick={onClose}
            title={translate('actions.close')}
          />
        )}
        <Box
          className={cx(styles['mobile-popup-content'], {
            [styles['mobile-popup-content--no-close-button']]: !onClose,
          })}
        >
          {children}
        </Box>
      </Box>
    </>,
    document.body,
  );
};

MobilePopup.Footer = Footer;
export default MobilePopup;
